import * as types from '../../action-types';


export const navAccess = payload => ({
  type: types.MODIFY_NAV_ACCESS,
  payload
});


